export enum KeyCode {
    ArrowDown = 40,
    ArrowLeft = 37,
    ArrowRight = 39,
    ArrowUp = 38,
    At = 50, // @
    Backspace = 8,
    Delete = 46,
    Enter = 13,
    ForwardSlash = 191, // '/'
    Esc = 27,
    OpeningCurlyBracket = 219, // '{'
    Semicolon = 186,
    SemicolonMozilla = 59,
    Space = 32,
    Tab = 9,
}
